var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDisease04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59375 20.5004L12.7051 18.1409C14.7456 16.9713 16.0013 14.7992 16.0013 12.4448V5.33594",
    stroke: "#E66161",
    strokeWidth: 3.03796,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4037 20.5004L19.2923 18.1409C17.2518 16.9713 15.9961 14.7992 15.9961 12.4448V5.33594",
    stroke: "#E66161",
    strokeWidth: 3.03796,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0938 10.5287V21.3894C19.0938 23.7742 20.6988 25.8653 23.0026 26.478L27.3722 27.6425C29.0583 28.0932 30.7089 26.797 30.6633 25.0501C30.6025 22.6552 30.4304 19.6122 29.9696 17.9616C28.9874 14.4477 26.5266 10.9287 22.4355 8.57428C20.952 7.71859 19.0938 8.81732 19.0938 10.5287Z",
    fill: "#EE9191"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9025 10.5287V21.3894C12.9025 23.7742 11.2975 25.8653 8.99367 26.478L4.62407 27.6425C2.93801 28.0932 1.28738 26.797 1.33295 25.0501C1.39371 22.6552 1.56586 19.6122 2.02662 17.9616C3.00889 14.4477 5.46964 10.9287 9.56076 8.57428C11.0443 7.71859 12.9025 8.81732 12.9025 10.5287Z",
    fill: "#EE9191"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8681 24.158C24.8803 24.158 25.701 23.3374 25.701 22.3251C25.701 21.3128 24.8803 20.4922 23.8681 20.4922C22.8558 20.4922 22.0352 21.3128 22.0352 22.3251C22.0352 23.3374 22.8558 24.158 23.8681 24.158Z",
    fill: "#E66161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8329 17.4666C9.84519 17.4666 10.6658 16.646 10.6658 15.6337C10.6658 14.6214 9.84519 13.8008 8.8329 13.8008C7.82062 13.8008 7 14.6214 7 15.6337C7 16.646 7.82062 17.4666 8.8329 17.4666Z",
    fill: "#E66161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9864 19.3557C27.6995 19.3557 28.2776 18.7776 28.2776 18.0646C28.2776 17.3515 27.6995 16.7734 26.9864 16.7734C26.2734 16.7734 25.6953 17.3515 25.6953 18.0646C25.6953 18.7776 26.2734 19.3557 26.9864 19.3557Z",
    fill: "#E66161"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96301 20.6448C5.67608 20.6448 6.25414 20.0667 6.25414 19.3536C6.25414 18.6406 5.67608 18.0625 4.96301 18.0625C4.24993 18.0625 3.67188 18.6406 3.67188 19.3536C3.67188 20.0667 4.24993 20.6448 4.96301 20.6448Z",
    fill: "#E66161"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1875 17.0089C22.1875 15.8241 23.1445 14.8672 24.3293 14.8672",
    stroke: "#E66161",
    strokeWidth: 2.53163,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60688 21.3516C9.50561 22.5313 8.47271 23.4072 7.29297 23.306",
    stroke: "#E66161",
    strokeWidth: 2.53163,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDisease04);
export default __webpack_public_path__ + "static/media/i_disease_04.56ab94ff06e03f25719b27d4fe09a4ce.svg";
export { ForwardRef as ReactComponent };